import { createI18n } from 'vue-i18n';
import type { App } from 'vue';

import en from '../../../apps/helium/src/locales/en.json';
import fa from '../../../apps/helium/src/locales/fa.json';

function createI18nInstance() {
  return createI18n({
    legacy: false,
    locale: 'fa',
    fallbackLocale: 'en',
    messages: {
      en,
      fa,
    },
    datetimeFormats: {
      fa: {
        shortDate: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        },
        shortTime: {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        },
        longDate: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        },
      },
      en: {
        shortDate: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour12: false,
        },
        shortTime: {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        },
        longDate: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        },
      },
    },
  });
}

const i18n = createI18nInstance();

function install(app: App, i18n: ReturnType<typeof createI18nInstance>) {
  app.use(i18n);
}

export { createI18nInstance, i18n, install };
